import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import TableOrder from "./pages/TableOrder";
import { AuthProvider } from "./context/AuthContext";
import { MusicPlayerProvider } from "./components/music/MusicPlayerProvider";
import MusicBar from "./components/music/MusicBar";

function App() {
  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const root = document.documentElement;
    let frameId = null;

    const applyViewportVars = () => {
      root.style.setProperty("--app-safe-bottom", "env(safe-area-inset-bottom, 0px)");

      // On touch/mobile browsers, keep CSS `lvh` as the stable viewport height.
      // Dynamic JS height updates make Safari jump when top/bottom browser chrome appears.
      const isCoarsePointer = window.matchMedia?.("(pointer: coarse)").matches;
      if (isCoarsePointer) {
        root.style.removeProperty("--app-visible-height");
        root.style.removeProperty("--app-toolbar-height");
        root.style.removeProperty("--app-height");
        return;
      }

      const visualViewport = window.visualViewport;
      const layoutHeight = Math.round(window.innerHeight || 0);
      const visibleHeight = Math.round(visualViewport?.height || layoutHeight || 0);

      root.style.setProperty("--app-visible-height", `${visibleHeight}px`);
      root.style.setProperty("--app-toolbar-height", "0px");
      root.style.setProperty("--app-height", `${visibleHeight}px`);
    };

    const updateViewportVars = () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
      frameId = window.requestAnimationFrame(() => {
        frameId = null;
        applyViewportVars();
      });
    };

    applyViewportVars();
    window.addEventListener("resize", updateViewportVars);
    window.addEventListener("orientationchange", updateViewportVars);
    window.visualViewport?.addEventListener("resize", updateViewportVars);

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
      window.removeEventListener("resize", updateViewportVars);
      window.removeEventListener("orientationchange", updateViewportVars);
      window.visualViewport?.removeEventListener("resize", updateViewportVars);
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <MusicPlayerProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/t/:slug" element={<TableOrder />} />
            </Routes>
          </BrowserRouter>
          <MusicBar />
        </MusicPlayerProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
